const mediaItems = [
  {
    id: 1,
    title: '\u300a\u661f\u6cb3\u957f\u660e\u300b',
    tag: '\u53e4\u88c5\u7384\u5e7b',
    desc: '\u9876\u6d41\u53e4\u88c5\u5927\u5267\uff0c\u5168\u7f51\u9996\u64ad',
    views: '1.2\u4ebf',
    rating: '9.4',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20drama%20poster%20style%20with%20ancient%20Chinese%20palace%20and%20flowing%20silk%20ribbons%20in%20warm%20coral%20and%20gold%20tones%2C%20elegant%20composition%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20misty%20atmosphere%2C%20vertical%20movie%20poster%20layout%2C%20clean%20minimal%20background%20with%20gradient%20depth&width=600&height=800&seq=media-card-01&orientation=portrait',
    season: '\u66f4\u65b0\u81f336\u96c6',
  },
  {
    id: 2,
    title: '\u300a\u98ce\u66b4\u8ffd\u51fb\u300b',
    tag: '\u52a8\u4f5c\u5927\u7247',
    desc: '\u8d85\u71c3\u52a8\u4f5c\u5de8\u5236\uff0c\u9662\u7ebf\u540c\u6b65',
    views: '9800\u4e07',
    rating: '9.1',
    img: 'https://readdy.ai/api/search-image?query=Action%20movie%20poster%20style%20with%20dynamic%20urban%20night%20scene%20and%20dramatic%20lighting%20effects%2C%20warm%20orange%20and%20red%20color%20grading%2C%20cinematic%20composition%2C%20intense%20atmosphere%2C%20vertical%20poster%20layout%2C%20clean%20background%20with%20dark%20gradient%20and%20light%20streaks&width=600&height=800&seq=media-card-02&orientation=portrait',
    season: 'VIP\u5168\u96c6',
  },
  {
    id: 3,
    title: '\u300a\u6b22\u4e50\u5468\u672b\u300b',
    tag: '\u70ed\u95e8\u7efc\u827a',
    desc: '\u5168\u660e\u661f\u9635\u5bb9\uff0c\u6b22\u7b11\u4e0d\u65ad',
    views: '7600\u4e07',
    rating: '9.6',
    img: 'https://readdy.ai/api/search-image?query=Variety%20show%20poster%20style%20with%20colorful%20vibrant%20stage%20lights%20and%20cheerful%20atmosphere%2C%20warm%20golden%20and%20pink%20tones%2C%20entertainment%20theme%2C%20bright%20dynamic%20composition%2C%20vertical%20poster%20layout%2C%20clean%20background%20with%20soft%20gradient&width=600&height=800&seq=media-card-03&orientation=portrait',
    season: '\u6bcf\u5468\u516d\u66f4\u65b0',
  },
  {
    id: 4,
    title: '\u300a\u661f\u9645\u7eaa\u5143\u300b',
    tag: '\u56fd\u4ea7\u52a8\u6f2b',
    desc: '\u56fd\u6f2b\u9ed1\u9a6c\uff0c\u5168\u7f51\u7206\u706b',
    views: '1.5\u4ebf',
    rating: '9.7',
    img: 'https://readdy.ai/api/search-image?query=Anime%20poster%20style%20with%20futuristic%20sci-fi%20cityscape%20and%20glowing%20neon%20elements%2C%20warm%20coral%20and%20deep%20purple-blue%20contrast%20tones%2C%20dynamic%20character%20silhouette%2C%20cinematic%20atmosphere%2C%20vertical%20poster%20layout%2C%20clean%20dark%20gradient%20background&width=600&height=800&seq=media-card-04&orientation=portrait',
    season: '\u5b8c\u7ed3\u5168\u96c6',
  },
];

export default function MediaSection() {
  const handleClick = () => {
    const el = document.querySelector('#media');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-3 mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
              热门推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              精选热播内容，每日更新推荐
            </p>
          </div>
          <a
            href="#media"
            onClick={(e) => { e.preventDefault(); handleClick(); }}
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            全部推荐 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href={`#media-${item.id}`}
              className="group block cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
                    {item.rating}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <span className="block text-xs text-accent-400 font-medium mb-0.5">
                    {item.tag}
                  </span>
                  <h3 className="text-sm md:text-base font-semibold text-background-50 mb-1">
                    {item.title}
                  </h3>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-background-50/70">{item.desc}</span>
                    <span className="text-xs text-background-50/50">{item.views}</span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}